import {
    fetchUserWithLocation,
    lookupUserByEmail
} from "../../users/services/UsersService.ts";
import {HandoffClient} from "../types.ts";
import {
    HANDOFF_ERROR_CODES,
    HandoffError
} from "./HandoffError.ts";

// Read-only tenant-management lookup; never touches the account list.
export const resolveClientForEmail = async (clients: HandoffClient[], email: string): Promise<HandoffClient> => {
    if (clients.length === 1) {
        return clients[0];
    }

    const {data, status} = await lookupUserByEmail(email);
    if (status !== 302 || !data.location) {
        throw new HandoffError(HANDOFF_ERROR_CODES.accountNotFound);
    }

    const user = await fetchUserWithLocation(data.location);
    const match = clients.find((c) => c.poolId === user['cognito-user-pool-id']);
    if (!match) {
        throw new HandoffError(HANDOFF_ERROR_CODES.poolNotAllowed);
    }
    return match;
};
